<template>
  <div>
    <el-table
      :row-style="{ height: '36px' }"
      :cell-style="{ padding: '0px' }"
      :header-row-style="{ height: '20px' }"
      :header-cell-style="{
        background: '#eef1f6',
        padding: '6px 0',
      }"
      style="width: 100%; color: #606266"
      ref="multipleTable5"
      :data="tableData"
      v-loading="loading"
      element-loading-text="拼命加载中"
      tooltip-effect="dark"
      :height="clientHeight"
    >
      <!--           <el-table-column type="selection"
                           width="55"> </el-table-column> -->
      <el-table-column
        v-for="(item, index) in currentcloumn.title"
        :key="index"
        show-overflow-tooltip
        :prop="currentcloumn.enname[index]"
        :label="item"
        min-width="150"
        :sort-method="
          (a, b) => {
            return a[item.props] - b[item.props];
          }
        "
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-popconfirm
              title="是否确认审核通过 将人员纳入本单位？"
              @confirm="executeChange(scope.row)"
            >
              <el-button type="text" size="small" slot="reference"
                >审核通过</el-button
              >
            </el-popconfirm>
            &nbsp;&nbsp;
            <el-popconfirm title="是否确认退回申请？" @confirm="recycleChange(scope.row)">
              <el-button type="text" size="small" slot="reference"
                >退回</el-button
              >
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagi-nation
      :Count="Count"
      @size-change="handleSizeChange"
      @current-change="onCurrentChange"
      ref="pagination"
    ></pagi-nation>
  </div>
</template>

<script>
import pagiNation from "@/components/pagiNation";
export default {
  components: {
    pagiNation,
  },
  data() {
    return {
      tableData: [],
      pagiisshow: false,
      loading: false,
      Count: 0,
      clientHeight: 0,
      pageNo:1,
      pageNum:15,
      currentcloumn: {
        title: ["姓名", "电话", "身份证号", "单位"],
        enname: ["name", "mobile", "idcard", "department"],
      },
    };
  },
  created() {
    let that = this;
    that.clientHeight = document.documentElement.clientHeight - 220;
    window.onresize = () => {
      that.clientHeight = document.documentElement.clientHeight - 220;
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
        const dwform = JSON.parse(localStorage.getItem("dwform"));
      let params = {
        department:dwform.department,
        pageNo:this.pageNo,
        pageNum:this.pageNum
      };
      this.loading = true;
      this.$http.get(this.$Api.getChangeList, { params }).then((res) => {
        this.loading=false
        if (res.data.errcode == 0) {
          this.tableData = res.data.datalist;
          this.Count = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
        this.pageNum = val;

      this.getData();
    },
    onCurrentChange(val) {
        this.pageNo = val;
      this.getData();
    },
    recycleChange(row){
     let params = {
        row_id:row.row_id,
      };
      this.$http.get(this.$Api.recycleChange, { params }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message({
            message: "退回成功",
            type: "success",
          });
          this.getData();
        } else {
          this.$message({
            message: '退回失败',
            type: "error",
          });
        }
      });
    },
    executeChange(row){
        let params = {
        row_id:row.row_id,
      };
      this.$http.get(this.$Api.executeChange, { params }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message({
            message: "审核通过",
            type: "success",
          });
          this.getData();
        } else {
          this.$message({
            message: '审核失败',
            type: "error",
          });
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
</style>